import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations, LANGUAGES } from '../i18n/translations';

const STORAGE_KEY = 'padaid_lang';
const LanguageContext = createContext(null);

const applyDir = (code) => {
  const meta = LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
  document.documentElement.setAttribute('lang', code);
  document.documentElement.setAttribute('dir', meta.dir);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && translations[saved]) return saved;
    } catch (e) { /* ignore */ }
    return 'fr';
  });

  useEffect(() => { applyDir(lang); }, [lang]);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    try { localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
    setLangState(code);
  }, []);

  const t = useCallback((key) => {
    return (translations[lang] && translations[lang][key]) || translations.fr[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: 'fr', setLang: () => {}, t: (k) => (translations.fr[k] || k), languages: LANGUAGES };
  return ctx;
};
